﻿import { Model } from 'pinia-orm'
import { Num, Str } from 'pinia-orm/decorators'

const REGION_BY_DISTRICT: Record<string, number> = {
    '11': 11, '12': 11,
    '13': 13,
    '14': 14, '15': 14,
    '16': 16, '17': 16,
    '20': 20, '21': 20,
    '22': 22, '23': 22,
    '24': 24
}

function districtPrefix ( id: number | string | null | undefined ): string | null {
    if ( id === null || id === undefined )
        return null

    const s = String( id )

    if ( s.length < 2 )
        return null

    return s.substring( 0, 2 )
}

function isNonDistrict ( prefix: string | null ): boolean {
    if ( prefix === null )
        return true

    const n = parseInt( prefix )

    return isNaN( n ) || n >= 60
}

export default class Club extends Model {
    static entity = 'clubs'

    @Num( 0, { notNullable: true } ) declare id: number
    @Str( '', { notNullable: true } ) declare name: string
    @Str( null ) declare shortcut: string | null
    @Str( null ) declare street: string | null
    @Str( null ) declare city: string | null
    @Str( null ) declare zip: string | null
    @Str( null ) declare manager: string | null
    @Str( null ) declare email: string | null

    get fullName (): string {
        return this.id + ' ' + this.name
    }

    isSameRegion ( clubId: number | string ): boolean {
        const p1 = districtPrefix( this.id )
        const p2 = districtPrefix( clubId )

        if ( isNonDistrict( p1 ) || isNonDistrict( p2 ) )
            return false

        const r1 = REGION_BY_DISTRICT[ p1 as string ]
        const r2 = REGION_BY_DISTRICT[ p2 as string ]

        if ( r1 === undefined || r2 === undefined )
            return false

        return r1 === r2
    }

    isSameDistrict ( clubId: number | string ): boolean {
        const p1 = districtPrefix( this.id )
        const p2 = districtPrefix( clubId )

        if ( isNonDistrict( p1 ) || isNonDistrict( p2 ) )
            return false

        return p1 === p2
    }

	static piniaOptions = {
		persist: true
	}

}
